import { Component, ElementRef, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AssetInfo, ComponentBase, T4TurboOrderService } from 't4core';
import { AddSubscriptionDialogComponent } from '../../dialogs/AddSubscription/AddSubscriptionDialog';

@Component({
  selector: 't4order-subscriptions',
  templateUrl: './Subscription.html',
  styleUrls: ['./Subscription.css']
})
export class SubscriptionComponent extends ComponentBase {

  constructor(el: ElementRef, private orderSvc: T4TurboOrderService, private fb: FormBuilder) {
    super();

  }
  public isLoading: boolean = false;
  public subscriptions: any[];

  public assets: any[];
  public formatedAssets: any[] = [];

  @Input() public contextId: string;

  async ngOnInit() {
    this.loadData();
  }

  public async addEvent() {

    var result = await this.Dialog.open(AddSubscriptionDialogComponent, {
      width: '700px',
      data: { ContextId: this.contextId }
    }).afterClosed().toPromise();

    if (result) {
      this.loadData();
    }

  }


  public async endSubscription(row: any) {

    var confirm = await this.UI.confirm("Turbo.Order.Subscription.ConfirmDeleteHeader", "Are you sure?", "Turbo.Order.Subscription.ConfirmDeleteMessage", "Do you want to end the subscription '{0}' ?", null, [row.Product.Name]);
    if (confirm) {
      this.isLoading = true;
      const result = await this.Api.post<boolean>("TurboOrder/EndTransaction", null, { contextId: this.contextId, id : row.Id });
      if (result) {
        this.UI.snackBarLocal('Turbo.Order.Subscription.ConfirmDeleteSuccess', 'Successfully ended the subscription.')
        this.loadData();
      }
      else {
        this.UI.snackBarLocal('Turbo.Order.Subscription.ConfirmDeleteFailed', 'Failed to end the subscription.')
      }
      this.isLoading = false;
    }
 
  }

  async loadData(){
    this.isLoading = true

    this.subscriptions = await this.Api.get<any[]>("TurboOrder/GetAllSubscriptions", { contextId: this.contextId });

    this.assets = await this.Api.get<AssetInfo[]>("Service/GetActiveAssets", { contextId: this.contextId });

    this.formatedAssets = this.assets
      .flatMap(asset =>
        asset.AssetTransactions.map(transaction => ({
          Name: asset.Product.Name,
          SerialId: asset.SerialId,
          StartDate: transaction.StartDate,
          EndDate: transaction.EndDate,
          LastInvoiceDate: transaction.LastInvoiceDate,
          Count: transaction.InvoiceCount,
          InvoiceSum: transaction.InvoiceSum,
        }))
      )
      .sort(
        (a, b) => new Date(b.StartDate).getTime() - new Date(a.StartDate).getTime()
    );


    console.log(this.formatedAssets);

    this.isLoading = false;
  }

}
